import React from "react";
import { ImCross } from "react-icons/im";
import { CustomizedSnackbars } from "../../MUI/MuiComponent";

export const WhatsWeC = ({
  state,
  setState,
  img,
  des,
  boxClass,
  imgClass,
  downloadNoti,
}) => {
  return (
    <div
      className={`${
        state
          ? "whatsapp-QR-code-container active-whatsapp-QR-code-container"
          : "whatsapp-QR-code-container"
      }`}
    >
      <div className={boxClass}>
        <img src={img} alt="WhatsAppQRCode" className={imgClass} />
        <p className="QR-first-p">{des}</p>
        <p className="spna-QR">Or</p>
        <p className="QR-second-p">for using later</p>
        <div className="flex-center-qr-btns">
        <CustomizedSnackbars
          btnText="Download"
          downloadImg={img}
          downloadNoti={downloadNoti}
        />
        </div>
        <button
          onClick={() => {
            setState(false);
          }}
          className="QR-CODE-BTN-CLOSE whatsapp-cross-btn"
        >
          <ImCross />
        </button>
      </div>
    </div>
  );
};
